import {createAction, props} from '@ngrx/store';
import { DocStereoTypeDto } from '../../models/DocStereoTypeDto';

export enum DSTActionTypes {
    RetrievedDstListType = '[Generic Documents API] Generic Documents API Success',    
    InvokeGenericDocumentApiType = '[Generic Documents API] Invoke API',
    AddDocStereoType = '[Document Stereo Type] Added Successfully',
    InvokeAddDocStereoType = '[Document Stereo Type]  Invoke API'
    
}


export const retrievedDocStereoList = createAction(DSTActionTypes.RetrievedDstListType, props<{docstereotypes: DocStereoTypeDto[]}>());
export const invokeGenericDocumentsApi = createAction(DSTActionTypes.InvokeGenericDocumentApiType,props<{dbname: string}>());

export const addNewDocStereoType = createAction(DSTActionTypes.AddDocStereoType, props<{docstereotype: DocStereoTypeDto}>());
export const invokeAddDocStereoTypeApi = createAction(DSTActionTypes.InvokeGenericDocumentApiType,props<{docstereotype: DocStereoTypeDto, dbname: string}>());





